module.exports = __webpack_public_path__ + "static/media/newsletter-march-2022-4.d50e448e.png";